import { render, staticRenderFns } from "./JobProfileCard.vue?vue&type=template&id=68199f6b&scoped=true&"
import script from "./JobProfileCard.vue?vue&type=script&lang=js&"
export * from "./JobProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./JobProfileCard.vue?vue&type=style&index=0&id=68199f6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68199f6b",
  null
  
)

export default component.exports